import React from 'react';
import clsx from 'clsx';
import { deburr } from 'lodash';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';

import { LoaderSpinner } from 'carbon-react/lib/components/loader-spinner';

import { getPredictPredictionsPageUrl, ROUTES } from '@futrli/shared-services';

import { BalanceSheetV2 } from '../balance-sheet/balance-sheet-v2';
import { CashFlowStatementV2 } from '../cash-flow-statement/cash-flow-statement-v2';
import { ConsolidatedForecastReportStructureWithTabs } from '../../../../core/types';
import { Invoices } from '../invoices/invoices';
import { ProfitAndLossV2 } from '../profit-and-loss/profit-and-loss-v2';
import { PredictionsSubTabUK } from '../predictions-sub-tab/predictions-sub-tab-uk/predictions-sub-tab-uk';
import { usePredictionsInfoContext } from '../../context/predictions-info-context';

import styles from './predictions-nav-data-controls.scss';

const ORGANISATION_PREDICTION_ROUTES = [
  {
    route: ROUTES.INVOICES,
    routeComponent: Invoices
  },
  {
    route: ROUTES.PROFIT_AND_LOSS,
    routeComponent: ProfitAndLossV2
  },
  {
    route: ROUTES.BALANCE_SHEET,
    routeComponent: BalanceSheetV2
  },
  {
    route: ROUTES.CASH_FLOW_STATEMENT,
    routeComponent: CashFlowStatementV2
  }
];

export const PredictionsRouterUKV2 = () => {
  const { forecastReportV2: forecastReport } = usePredictionsInfoContext();
  const subtabs = (forecastReport?.structure as ConsolidatedForecastReportStructureWithTabs)?.tabs || [];
  const { workspaceId, organisationId, forecastId } = useParams();

  // Wait for forecastReport to load before rendering routes to prevent premature redirects
  if (!forecastReport) {
    return <LoaderSpinner />;
  }

  return (
    <div className={clsx(styles.content, styles.pageWidthWrapper)}>
      <Routes>
        {ORGANISATION_PREDICTION_ROUTES.map(({ route, routeComponent: RouteComponent }) => (
          <Route key={route} path={route} element={<RouteComponent />} />
        ))}
        {subtabs.map(tab => {
          const route = encodeURI(deburr(tab.id || tab.label).replace(/[ _]/g, '-'));
          return <Route key={`${route}-route`} path={route} element={<PredictionsSubTabUK tab={tab} />} />;
        })}
        <Route
          path="*"
          element={
            <Navigate
              to={`${getPredictPredictionsPageUrl(workspaceId!, organisationId!, forecastId!)}${ROUTES.INVOICES}`}
            />
          }
        />
      </Routes>
    </div>
  );
};
